import useSentryCaptureException from '../../../hooks/useSentryCaptureException';

const SentryErrorWrapper = ({ children }) => {
  useSentryCaptureException();

  return children;
};

export default SentryErrorWrapper;
